import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSingleEvent, getSingleEventWithFilter } from "../../redux/action/eventsAction";
import { endOfMonth, startOfMonth } from "date-fns";
import DatePicker from "react-datepicker";
import { SpinLoading } from "../../modules";
import { useParams } from "react-router-dom";
import ExportToExcel from '../../components/events/ExportToExcel'
function SignleEvent() {
    const dispatch = useDispatch();
    const { eventType } = useParams();
    const { loading, singleEvent } = useSelector((state) => state.singleEvent);
    const [startDate, setStartDate] = useState(startOfMonth(new Date()));
    const [endDate, setEndDate] = useState(endOfMonth(new Date()));
    const [city, setCity] = useState('')
    const [state, setState] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')

    const onChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    const handleSearch = () => {
        dispatch(getSingleEventWithFilter(eventType, startDate, endDate, city, state, phoneNumber));
    }

    const reset = () => {
        setCity('')
        setState('')
        setPhoneNumber('')
    }
    useEffect(() => {
        if (endDate) {
            dispatch(getSingleEvent(eventType, startDate, endDate));
        }
    }, [dispatch, startDate, endDate]);


    return (
        <div>
            <div
                className="flex space-between align-center  pr-1 mb-1"
                style={{ marginTop: "-15px" }}
            >
                <div>
                    <b>{eventType} &nbsp; Events</b>
                    <span className="small-text  ">
                        &nbsp; ({startDate?.toDateString()} - {endDate?.toDateString()})
                    </span>
                </div>



                <span className="flex align-center gap-1">
                    {loading && <SpinLoading />}
                    <div className="chart-date-select btn-outline flex align-center gap-1 ">
                        <DatePicker
                            selected={startDate}
                            onChange={onChange}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            className="browser-default "
                            dateFormat="dd/MM/yyyy"
                        />
                        <span className="material-symbols-outlined">calendar_month</span>
                    </div>
                    <ExportToExcel data={singleEvent} fileName={'test'} loading={loading} />
                </span>


            </div>
            <span className="flex align-end justify-end full-width  gap-1">
                <div className=" flex align-center gap-1 ">
                    <from className='flex gap-1 align-center' >
                        <input
                            className="browser-default input-style"
                            type="text"
                            placeholder="City"
                        />
                        <input
                            className="browser-default input-style"
                            type="text"
                            placeholder="State"
                        />
                        <input
                            className="browser-default input-style"
                            type="text"
                            placeholder="State"
                        />
                        <button
                            className="btn-outline"
                            onClick={reset}
                            style={{ width: "240px" }}
                        >
                            Re-set
                        </button>
                        <button className="btn-outline" onClick={handleSearch}>
                            <span class="material-symbols-outlined">search</span>
                            Search
                        </button>
                    </from>

                </div>
            </span>
            <table>
                <thead>
                    <tr className="small-text">
                        <th>#</th>
                        <th>Event Name</th>
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Verified</th>
                        <th>Organization</th>
                        <th>User Category</th>
                        <th>Seen At</th>
                        <th>State</th>
                        <th>City</th>



                    </tr>
                </thead>
                <tbody>
                    {singleEvent.map((item, index) => {
                        return (
                            <tr className="small-text" key={index}>
                                <td>{index + 1}</td>
                                <td>{item.eventType}</td>
                                <td>{item.user?.name}</td>
                                <td>{item.user?.phoneNumber}</td>
                                <td>{item?.verified ? "Verified" : "Not Verified"}</td>
                                <td>{item.user?.organization}</td>
                                <td>{item?.userCategory || item.profile?.userCategory }</td>
                                <td>{new Date(item.timestamp).toLocaleString(undefined, { timeZone: 'Asia/Kolkata' })}</td>
                                <td>{item.location?.state}</td>
                                <td>{item.location?.city}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default SignleEvent